import { useNavigate } from 'react-router-dom';

export default function PrivacyFooter() {
  const navigate = useNavigate();

  const handleCtaClick = () => {
    navigate('/');
    setTimeout(() => {
      const el = document.getElementById('final-cta');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  return (
    <footer className="relative py-16 sm:py-20 lg:py-24 bg-[#f5f1e8]">
      <div className="max-w-[1000px] mx-auto px-4 sm:px-6 lg:px-8 text-center space-y-8">
        <h2 className="font-harvey-serif text-[#09090b] text-[28px] sm:text-[36px] lg:text-[44px] font-normal tracking-tight leading-tight">
          Ready to Draft Without Compromise?
        </h2>

        <p className="font-harvey-sans text-[#52525b] text-base sm:text-lg lg:text-xl font-light tracking-wide max-w-[700px] mx-auto">
          Join 500+ attorneys who refuse to choose between speed and privilege
        </p>

        <button
          onClick={handleCtaClick}
          className="bg-[#d4af37] text-black text-[15px] sm:text-[18px] font-bold px-6 sm:px-8 py-4 rounded-xl hover:shadow-[0_0_30px_rgba(212,175,55,0.6)] transition-all duration-200 whitespace-nowrap cursor-pointer"
        >
          Claim Founder Spot
        </button>

        <div className="pt-8 border-t border-[#d4af37]/20">
          <p className="font-harvey-sans text-[#71717a] text-xs sm:text-sm font-light tracking-wide">
            © 2026 HushLegal. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
